import React from 'react';
import { formatDistance, subDays } from 'date-fns';
import clsx from 'clsx';
import isEmpty from 'lodash/isEmpty';

import styles from 'styles/components/profile/Profile.module.scss';

const WorkingStats = ({
  working_stats = {},
  noPaddingLeft = false,
  newStyles = {},
  showAvgResponseTime = true,
  showResponseRate = true,
  showGigsCompleted = true,
  showWorkedWith = true,
  showActiveGigCount = true,
}) => {
  const getAverageResponseTime = () => {
    if (working_stats.response_time_minutes === 0 || isNaN(working_stats.response_time_minutes)) {
      return '/';
    } else if (working_stats.response_time_minutes < 60) {
      return `${working_stats.response_time_minutes}m`;
    } else if (working_stats.response_time_minutes / 60 > 72) {
      return formatDistance(
        subDays(new Date(), working_stats.response_time_minutes / 60 / 24),
        new Date()
      );
    }

    return `${Math.round(working_stats.response_time_minutes / 60)}h`;
  };

  return (
    <div
      className={clsx(
        styles.influencerInfo,
        { [styles.noPaddingLeft]: noPaddingLeft },
        { [newStyles]: !isEmpty(newStyles) }
      )}
    >
      {showAvgResponseTime && (
        <div>
          Average response time: <span className={styles.bold}>{getAverageResponseTime()}</span>
        </div>
      )}

      {showResponseRate && working_stats.response_rate !== 0 && (
        <div>
          Response rate: <span className={styles.bold}>{`${working_stats.response_rate}%`}</span>
        </div>
      )}

      {showGigsCompleted && (
        <div>
          Gigs completed: <span className={styles.bold}>{working_stats.gigs_count}</span>
        </div>
      )}

      {showWorkedWith && (
        <div>
          Buyers worked with: <span className={styles.bold}>{working_stats.advertisers_count}</span>
        </div>
      )}

      {showActiveGigCount && (
        <div>
          Active gigs: <span className={styles.bold}>{working_stats.active_gigs_count}</span>
        </div>
      )}
    </div>
  );
};

export default WorkingStats;
